export default[  {
    path: "/user/address/list",
    component: () => import( /* webpackChunkName: "user" */ '@/page/user/address/list.vue')
  },{
    path: "/user/address/edit/:id",
    component: () => import( /* webpackChunkName: "user" */ '@/page/user/address/edit.vue')
  }]